import React from "react";
import SubPageHeading from "../../../../../Common/SubPageHeading";

const HospitalLinks = ({ hospitalList,county,handlerNavigation }) => {
 
  return (
    <>
    
    <SubPageHeading headingTitle={`Hospitals in ${county?'County':'New York'}`} instruction={`Click on a hospital name to select it.`} />
      <div className="paddingTop20px"></div>
      <ul>
      {hospitalList?.map((hospitalObj) => (
        <>
          <li key={hospitalObj?.hospitalId}
            className="colorBlue font16px textUnderlined padding0px"
            role="link"
            tabIndex="0"
            aria-label={hospitalObj?.hospitalId}
            onClick={(e) => handlerNavigation(hospitalObj)}
            onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
               handlerNavigation(hospitalObj)
          }
    }}
          >
            {hospitalObj?.hospitalName}
          </li>
          <br></br>
        </>
        
      ))}
      </ul>
    </>
  );
};
export default HospitalLinks;
